export const DRAWER_WIDTH = 240